import React from 'react';
import nextIcon from '@/assets/images/next-page.svg'
import preIcon from '@/assets/images/pre-page.svg'

const PageItem = ({ pageIndex, currentPage, setCurrentPage }) => {
  if(pageIndex <= 2) {
    return <li key={pageIndex} onClick={() => {setCurrentPage(pageIndex)}} className={currentPage === pageIndex ? 'active' : null}>{pageIndex}</li>
  } else if(currentPage - 3 <= pageIndex && currentPage + 3 >= pageIndex) {
    return <li key={pageIndex} onClick={() => {setCurrentPage(pageIndex)}} className={currentPage === pageIndex ? 'active' : null}>{pageIndex}</li>
  } else if (currentPage + 4 === pageIndex || currentPage - 4 === pageIndex) {
    return <li key={pageIndex} className="no-allow">...</li>
  } else {
    return null;
  }
}

export default ({ currentPage, totalPage, setCurrentPage }) => {

  const switchPrePage = () => {
    const prePage = currentPage - 1;
    if(prePage <= 0) {
      return;
    } 
    setCurrentPage(prePage);
  }

  const switchNextPage = () => {
    const nextPage = currentPage + 1;
    if(nextPage > totalPage) {
      return;
    } 
    setCurrentPage(nextPage);
  }

  return (
    <div className="pagination-container">
      <ul>
        <li onClick={switchPrePage}><img src={preIcon} /></li>
          {
            Array(totalPage).fill('').map((item, pageIndex) => {
              return (
                <PageItem
                  key={pageIndex}
                  pageIndex={pageIndex + 1} 
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  >
                </PageItem>
              )
            })
          }
        <li onClick={switchNextPage}><img src={nextIcon} /></li>
      </ul>
    </div>
  )
}